"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_KEY = void 0;
exports.STORAGE_KEY = "auth-tokens-".concat(process.env.NODE_ENV);
//# sourceMappingURL=StorageKey.js.map